import axios from "axios";

const apiClient = axios.create({
    baseURL: 'https://api.altynlogistics.com/api',
});

export default apiClient;